









import Vue from 'vue';

export default Vue.extend({
  name: 'SearchBox',
  props: {
    placeholder: {
      type: String,
      default: '検索',
    },
    value: String,
  },
});
